<template>
  <Layout>
    <PageHeader :title="page.title" :items="page.items" />

    <!-- main -->
    <b-row>
      <b-col lg="12">
        <!-- 查询条件 -->
        <b-card>
          <b-row>
            <b-col lg="4">
              <b-form-group
                label="Device Code Name"
                label-cols-sm="4"
                label-align-sm="right"
                label-for="Model-name"
              >
                <b-form-input
                  id="Model-name"
                  v-model="search_condition.modelName"
                  trim
                  placeholder="Please enter"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col lg="4">
              <b-form-group
                label="Device Name"
                label-cols-sm="4"
                label-align-sm="right"
                label-for="Device-name"
              >
                <b-form-input
                  id="Device-name"
                  v-model="search_condition.deviceName"
                  trim
                  placeholder="Please enter"
                ></b-form-input>
              </b-form-group>
            </b-col>

            <b-col lg="4">
              <b-button variant="primary" @click="search()">Search</b-button>
            </b-col>
          </b-row>
        </b-card>

        <b-card>
          <!-- table -->
          <b-button
            v-has="'cartridgeModel::Create'"
            @click="gotoAdd"
            variant="primary"
            >Create</b-button
          >

          <div class="table-responsive mb-0">
            <b-table
              show-empty
              empty-text="no records"
              id="table"
              head-variant="light"
              ref="table"
              :busy="isBusy"
              :striped="true"
              :items="provider"
              :fields="fields"
              :per-page="search_condition.pageSize"
              :current-page="search_condition.pageNum"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :filter="filter"
              :filter-includedfields="filterOn"
              @filtered="onFiltered"
            >
              <template v-slot:table-busy>
                <div class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>
              </template>

              <template v-slot:cell(index)="data">
                {{
                  data.index +
                  (search_condition.pageNum - 1) * search_condition.pageSize +
                  1
                }}
              </template>

              <template v-slot:cell(actions)="row">
                <b-button-group>
                  <b-button
                    v-has="'cartridgeModel::Modify'"
                    size="sm"
                    variant="info"
                    @click="edit(row.item, row.index, $event.target)"
                    class="mr-1"
                  >
                    Modify
                  </b-button>
                </b-button-group>
              </template>
            </b-table>
          </div>
          <!-- end table -->
          <!-- pagination -->
          <b-row v-if="has_data">
            <b-col>
              <div
                class="dataTables_paginate paging_simple_numbers float-right"
              >
                <ul class="pagination mb-0" v-if="rows != 0">
                  <b-pagination
                    v-model="search_condition.pageNum"
                    :per-page="10"
                    :total-rows="rows"
                    aria-controls="table"
                  >
                  </b-pagination>
                </ul>
              </div>
            </b-col>
          </b-row>
          <!-- end pagination -->
        </b-card>
      </b-col>
    </b-row>
  </Layout>
</template>
<script>
import DatePicker from "vue2-datepicker";
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";

/**
 * FAQ component
 */
export default {
  components: {
    Layout,
    PageHeader,
    DatePicker,
  },
  data() {
    return {
      page: {
        title: "Cartridge Model",
        items: [
          {
            text: "UNI-CORE",
            // href: "/"
          },
          {
            text: "Device Manage",
            // href: "/"
          },
          {
            text: "Cartridge Model",
            active: true,
          },
        ],
      },
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      filter: null,
      filterOn: [],
      sortBy: "id",
      sortDesc: false,
      fields: [
        { key: "index", label: "#", class: "text-center" },
        // {
        //   key: "modelName",
        //   label: "Model name",
        //   class: "text-center",
        // },
        // {
        //   key: "deviceModelName",
        //   label: "Applicable Device",
        //   class: "text-center",
        // },
        // {
        //   key: "heatingWireMaterial",
        //   label: "Heating Wire Material",
        //   class: "text-center",
        // },
        // {
        //   key: "heatingWireSize",
        //   label: "Heating Wire Size",
        //   class: "text-center",
        // },
        // {
        //   key: "heatingWirePorosity",
        //   label: "Heating Wire Porosity",
        //   class: "text-center",
        // },
        // {
        //   key: "oilInlet",
        //   label: "Oil Hole",
        //   class: "text-center",
        // },
        // {
        //   key: "resistance",
        //   label: "Resistance",
        //   class: "text-center",
        // },
        // {
        //   key: "cottonBag",
        //   label: "Cotton coil",
        //   formatter: (value) => {
        //     return value == 0 ? "Yes" : "No";
        //   },
        //   class: "text-center",
        // },
        // {
        //   key: "remarks",
        //   label: "Notes",
        //   class: "text-center",
        // },
        {
          key: "modelName",
          label: "Device Code Name",
          class: "text-center",
        },
        {
          key: "deviceName",
          label: "Device Name",
          class: "text-center",
        },
        {
          key: "brandIdentityId",
          label: "Brand Identity",
          formatter: (value) => {
            return value == 6
              ? "FC"
              : value == 7
              ? "FA"
              : value == 8
              ? "FB"
              : value == 9
              ? "FD"
              : "FE";
          },
          class: "text-center",
        },
        {
          key: "curveType",
          label: "Curve Type",
          formatter: (value) => {
            return value == 1
              ? "One curve"
              : "Two curve"
          },
          class: "text-center",
        },
        {
          key: "type",
          label: "Type",
          formatter: (value) => {
            return value == 1
              ? "Distillate Cartridge"
              : value == 2
              ? "Wax Cartridge"
              : value == 3
              ? "Disposable"
              : value == 4
              ? "Electromagnetic Cartridge"
              : value == 5
              ? "Nicotine Cartridge"
              : "Replaceable";
          },
          class: "text-center",
        },
        {
          key: "status",
          label: "Status",
          formatter: (value) => {
            return value == 0 ? "Enabled" : "Disabled";
          },
          class: "text-center",
        },
        {
          key: "remarks",
          label: "Notes",
          class: "text-center",
        },
        {
          key: "createTime",
          label: "Create Time",
          class: "text-center",
        },
        { key: "actions", label: "Opreration", class: "text-center" },
      ],
      search_condition: {
        pageNum: 1,
        pageSize: 10,
        modelName: "",
        deviceModelId: "",
      },
      isBusy: false,
      has_data: false,
      types: {
        statuss: [
          { text: "Please select", value: "", disabled: false },
          { text: "Enabled", value: 0, disabled: false },
          { text: "Disabled", value: 1, disabled: false },
        ],
        selectAllDeviceModel: [{ modelName: "Please select", id: "" }],
      },
    };
  },
  computed: {
    rows() {
      return this.totalRows;
    },
  },
  created() {
    this.init();
  },
  methods: {
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    gotoAdd() {
      this.$router.push("cartridgeModelAdd");
    },
    init() {
      this.$api.Dropdown.selectAllDeviceModel().then((res) => {
        if (res.success && res.data) {
          this.types.selectAllDeviceModel =
            this.types.selectAllDeviceModel.concat(res.data);
        } else {
          if (res.message) {
            this.$bvToast.toast(res.message);
          }
        }
      });
    },
    provider(ctx) {
      this.isBusy = true;
      return this.$api.CartridgeModel.testSmokeBombModelList(
        this.search_condition,
        ctx
      )
        .then((x) => {
          this.isBusy = false;
          if (x.total) {
            this.has_data = true;
            this.totalRows = x.total;
            return x.data;
          } else {
            this.has_data = false;
            return [];
          }
        })
        .catch((e) => {
          this.isBusy = false;
          this.has_data = false;
          return [];
        });
    },
    edit(item, index, button) {
      this.$router.push("cartridgeModelEdit?id=" + item.id);
    },
    search() {
      this.search_condition.pageNum = 1;
      this.$refs.table.refresh();
    },
  },
};
</script>
